/*
Purpose: Initialize Firebase SDK (Auth, Firestore, Storage, Functions).
Audience: App bootstrap.
What it does:
- Reads env vars and initializes Firebase app and service clients
Interplay:
- Exported db/auth/storage/functions instances are used across the app
*/
// src/firebase.js

import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import {
  getAuth,
  signInWithEmailAndPassword, // <-- Add this import
  createUserWithEmailAndPassword, // <-- Add this import
  signOut, // <-- Consider adding signOut and onAuthStateChanged for completeness
  onAuthStateChanged, // <-- Consider adding onAuthStateChanged for completeness
  updateProfile // <-- Add this import for profile updates
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration pulled from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export Firebase services
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Export the specific authentication methods that other components will need
export {
  signInWithEmailAndPassword, // <-- Add this export
  createUserWithEmailAndPassword, // <-- Add this export
  signOut, // <-- Add this export (used by App.js)
  onAuthStateChanged, // <-- Add this export (used by App.js)
  updateProfile // <-- Add this export for profile updates
};